// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-container {
  /* position: relative; */
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: #07070e;
}

.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled{
  color: #666666 !important;
  background: #919191 !important;
  border: 1px solid #999999 !important;

}

.top-left-area,
.top-right-area,
.bottom-left-area,
.bottom-right-area,
.bottom-area {
  position: absolute;

  justify-content: center;
  align-items: center;
  color: #fff;
}

.top-left-area {
  top: 0;
  left: 0;
  width: 200px;
  height: 200px;
}

.bottom-left-area {
  top: 205px;
  left: 0;
  width: 200px;
  bottom: 0;
}

.closeButton-events {
  height: 20px;
  padding: 5px;

}

.bottom-area {
  top: 205px;
  /* left: 40px; */
  width: 200px;
  bottom: 0;
  background-color: #282b30;
  border-radius: 10px 10px 0 0;
}

.bottom-right-area {
  top: 205px;
  left: 205px;
  right: 0;
  bottom: 0;
}

.vertical-line {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2px;
  background-color: #464545;
  cursor: col-resize;
  z-index: 9999;
}

.horizontal-line {
  position: absolute;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #464545;
  cursor: row-resize;
  z-index: 9999;
}

.horizontal-line-split {
  position: absolute;
  left: calc(50% - 50px);
  width: 100px;
  height: 3px;
  background-color: #9a9a9a;
  cursor: pointer;
  z-index: 9999;
  border-radius: 10%;
}

.horizontal-line-split.active {
  cursor: row-resize;
}

.window-area {
  position: absolute;
  transition: all 0.3s ease;
}

.open {
  z-index: 1;
}

.closed {
  z-index: 0;
}

.events-button {
  font-size: 20px;
  right: 5px;
  float: right;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-color: #282b30;
  color: #eee;
  margin: -5px 5px 5px 5px;
}

.close-button {
  background-color: #282b30;
  float: right;
  color: #eee;
  border-radius: 0 6px 0 0;
  cursor: pointer;
}

.window button {
  float: right;
  background-color: rgb(184, 70, 70);
  color: #eee;
}

select {
  background-color: #282b30;
  color: #eee;
}
`, "",{"version":3,"sources":["webpack://./src/components/presentation.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;;AAEtC;;AAEA;;;;;EAKE,kBAAkB;;EAElB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,UAAU;EACV,OAAO;EACP,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;;AAEd;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb","sourcesContent":[".app-container {\n  /* position: relative; */\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n  background-color: #07070e;\n}\n\n.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled{\n  color: #666666 !important;\n  background: #919191 !important;\n  border: 1px solid #999999 !important;\n\n}\n\n.top-left-area,\n.top-right-area,\n.bottom-left-area,\n.bottom-right-area,\n.bottom-area {\n  position: absolute;\n\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n}\n\n.top-left-area {\n  top: 0;\n  left: 0;\n  width: 200px;\n  height: 200px;\n}\n\n.bottom-left-area {\n  top: 205px;\n  left: 0;\n  width: 200px;\n  bottom: 0;\n}\n\n.closeButton-events {\n  height: 20px;\n  padding: 5px;\n\n}\n\n.bottom-area {\n  top: 205px;\n  /* left: 40px; */\n  width: 200px;\n  bottom: 0;\n  background-color: #282b30;\n  border-radius: 10px 10px 0 0;\n}\n\n.bottom-right-area {\n  top: 205px;\n  left: 205px;\n  right: 0;\n  bottom: 0;\n}\n\n.vertical-line {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 2px;\n  background-color: #464545;\n  cursor: col-resize;\n  z-index: 9999;\n}\n\n.horizontal-line {\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background-color: #464545;\n  cursor: row-resize;\n  z-index: 9999;\n}\n\n.horizontal-line-split {\n  position: absolute;\n  left: calc(50% - 50px);\n  width: 100px;\n  height: 3px;\n  background-color: #9a9a9a;\n  cursor: pointer;\n  z-index: 9999;\n  border-radius: 10%;\n}\n\n.horizontal-line-split.active {\n  cursor: row-resize;\n}\n\n.window-area {\n  position: absolute;\n  transition: all 0.3s ease;\n}\n\n.open {\n  z-index: 1;\n}\n\n.closed {\n  z-index: 0;\n}\n\n.events-button {\n  font-size: 20px;\n  right: 5px;\n  float: right;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  background-color: #282b30;\n  color: #eee;\n  margin: -5px 5px 5px 5px;\n}\n\n.close-button {\n  background-color: #282b30;\n  float: right;\n  color: #eee;\n  border-radius: 0 6px 0 0;\n  cursor: pointer;\n}\n\n.window button {\n  float: right;\n  background-color: rgb(184, 70, 70);\n  color: #eee;\n}\n\nselect {\n  background-color: #282b30;\n  color: #eee;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
